import { createContext, type ReactNode, useContext } from "react";

const LiveRowsRefreshingContext = createContext(false);

/**
 * Wraps the rows of a live table or grid. `refreshing` is true while the
 * rows shown are the last known ones and a fresh result is on its way.
 */
export function LiveRowsRefreshingProvider({
  refreshing,
  children,
}: Readonly<{ refreshing: boolean; children: ReactNode }>) {
  return (
    <LiveRowsRefreshingContext.Provider value={refreshing}>
      {children}
    </LiveRowsRefreshingContext.Provider>
  );
}

/**
 * Whether the cell or card this is called in shows rows that may be out of
 * date: a live table or grid with `staleWhileRevalidate` shows the last known
 * rows while it loads the current ones. Do not write from such a row (mutate,
 * upload, start work) while this is true; wait for the refresh. False outside
 * a live table or grid.
 */
export function useLiveRowsRefreshing(): boolean {
  return useContext(LiveRowsRefreshingContext);
}
